import type { ConversationResponse } from '@acme/api/admin';
import { formatTime } from '../lib';

export interface ConversationListItemProps {
  conversation: ConversationResponse;
  isSelected: boolean;
  onSelect: (conversation: ConversationResponse) => void;
}

export const ConversationListItem = (props: ConversationListItemProps) => {
  const userId = props.conversation.userId ?? '';
  const time = formatTime(props.conversation.lastMessage?.sentAt);

  return (
    <button
      key={props.conversation.id || userId}
      type="button"
      onClick={() => props.onSelect(props.conversation)}
      className={`flex w-full items-center px-4 py-1.5 text-left ${
        props.isSelected ? 'bg-gray-100' : 'hover:bg-gray-50'
      }`}
    >
      <div className="flex w-full flex-col justify-center gap-0.5">
        <div className="flex items-center justify-between gap-3">
          <p className="truncate text-base font-medium text-gray-900">
            {props.conversation.userName || '—'}
          </p>
          <p className="shrink-0 text-xs font-normal text-gray-500">{time}</p>
        </div>

        <div className="flex items-center justify-between gap-2">
          <p className="truncate text-sm font-normal text-gray-500">
            {props.conversation.lastMessage?.text || '—'}
          </p>
        </div>
      </div>
    </button>
  );
};
